import JSONAPISerializer from "@ember-data/serializer/json-api";
import { service } from "@ember/service";
import type SemeiaSessionService from "parog-web/services/session";
import { serializeToDateString } from "parog-web/utils/time";

export type PatientSerializedPayload = {
  data: {
    attributes: Record<string, string | null>;
    relationships: Record<string, string>;
  };
};

export default class extends JSONAPISerializer {
  @service declare session: SemeiaSessionService;

  attrs = {
    uuid: { serialize: false },
    passwordChangedAt: { serialize: false }
  };

  serialize(snapshot, options) {
    const json = super.serialize(snapshot, options) as PatientSerializedPayload;

    delete json.data.attributes["uses-the-app"];
    delete json.data.attributes["access-word"];
    delete json.data.attributes["patient-consent"];
    delete json.data.attributes["clinical-study-id"];
    delete json.data.attributes["has-ongoing-rch-survey-procedure"];
    delete json.data.attributes["has-ongoing-crohn-survey-procedure"];
    delete json.data.attributes["follow-up-reason-cached"];
    delete json.data.attributes["enrollment-status"];

    const birthday = snapshot.attr("birthday");
    if (birthday) {
      json.data.attributes.birthday = serializeToDateString(birthday);
    }

    if (!snapshot.record.isNew) {
      // Patients don't have the rights to update the health-centre.
      if (this.session.patient && json.data.relationships) {
        delete json.data.relationships["health-centre"];
      }
    }

    return json;
  }
}
